export const CHAT_LIGHTBOX_EVENT = `ai-chat-lightbox`;

export const dispatchChatLightboxEvent = (src: string) => {
  window.dispatchEvent(
    new CustomEvent<string>(CHAT_LIGHTBOX_EVENT, { detail: src }),
  );
};
